export enum FailureIconType {
	ERROR = 'o_cross',
	PROBLEM = 'problem',
	WARNING = 'failures',
}
